import * as React from "react";
import styled from "styled-components";
import { px2rem } from "utils/browser/resizer";
import { Color } from "config/index";
import { getLitbLangFn } from "utils/language";
import { ErrorpagePlaceholder } from "views/utils/imgUrls";

const EmptyPageWrap = styled.section`
	width: 100%;
	max-width: 100%;
	min-height: inherit;
	background: #fff;
	box-sizing: border-box;
	padding: ${px2rem(90)} ${px2rem(30)} 0;
	.img {
		width: 242px;
		// width: 64.5%;
		height: 120px;
		display: block;
		margin: 0 auto;
	}

	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: ${px2rem(15)} auto;
		color: #fff;
		width: ${px2rem(123)};
		width: fit-content;
		min-height: ${px2rem(36)};
		padding: 0.5rem 1rem;
		border-radius: 4px;
		text-align: center;
		word-wrap: break-word;
		line-height: ${px2rem(19)};
		background-color: ${Color.Main};
		font-size: ${px2rem(16)};
	}
`;
const EmptyPageWrapTips = styled.p`
	box-sizing: border-box;
	width: 100%;
	padding: ${px2rem(6)} 0 0;
	font-size: ${px2rem(14)};
	line-height: ${px2rem(19)};
	text-align: center;
	word-wrap: break-word;
	font-family: Avenir-Roman, Avenir;
	font-weight: normal;
	color: #666666;
`;

class EmptyPage extends React.Component<{ language: string }> {
	btnClick = () => {
		location.href = "https://www.miniinthebox.com";
	};

	render() {
		const { language } = this.props;
		return (
			<EmptyPageWrap>
				<img
					src={`${ErrorpagePlaceholder}`}
					className={"img"}
					alt="Page is blank"
				/>
				<EmptyPageWrapTips>{getLitbLangFn("Page is blank", language)}</EmptyPageWrapTips>
				<div className={"btn"} onClick={this.btnClick}>
					{getLitbLangFn("GoShopping", language)}
				</div>
			</EmptyPageWrap>
		);
	}
}

export default EmptyPage;
